import gql from 'graphql-tag';
import BASE_ORGANIZATION_ROLE_FRAGMENT from 'graph/fragments/organization-role';
import BASE_USER_LICENSE_USAGE_FRAGMENT from 'graph/fragments/user-license-usage';
import BASE_USER_FRAGMENT from 'graph/fragments/user';

const GET_ADMIN_USER_MANAGEMENT_USERS = gql`
  query getUserManagementUsers($where: UsersWhereInput) {
    organizations {
      id
      name
    }
    users(where: $where) {
      ...BaseUser
      licenseUsage {
        ...BaseUserLicenseUsage
      }
      organizationAssociations {
        organizationId
        organization {
          id
          name
        }
        organizationRoles {
          ...BaseOrganizationRole
        }
      }
    }
  }
  ${BASE_ORGANIZATION_ROLE_FRAGMENT}
  ${BASE_USER_LICENSE_USAGE_FRAGMENT}
  ${BASE_USER_FRAGMENT}
`;

export default GET_ADMIN_USER_MANAGEMENT_USERS;
